import React from "react";
import { withRouter } from "react-router-dom";

import { Box, Icon, useBackgroundColor } from "@seneca/senekit";

import SideDrawer, {
  Props as SideDrawerProps
} from "features/common/components/SideDrawer";
import Logo from "features/common/logos/Logo";
import NotificationDot from "features/parents/features/parent-navbar/components/NotificationDot";

type Props = SideDrawerProps & {
  children: {
    showNotificationDot?: boolean;
    options: (arg0: () => void, arg1: () => void) => React.ReactNode;
  };
};

function NavbarSideDrawer({
  children: { options, showNotificationDot }
}: Props) {
  const backgroundColor = useBackgroundColor();

  return (
    <SideDrawer
      openFromRight
      renderButton={(onClick: any) => (
        <Box
          width="32px"
          height="32px"
          position="relative"
          marginRight="large"
          onClick={onClick}
        >
          {showNotificationDot && (
            <Box position="absolute" top="-6px" right="-6px">
              <NotificationDot />
            </Box>
          )}
          <Icon
            iconName="hamburgerMenu"
            accessibilityLabel="Menu"
            size="fill"
            tone="neutral"
          />
        </Box>
      )}
      renderContents={(closeDrawer: any, openDrawer: any) => (
        <>
          <Box backgroundColor={backgroundColor} padding="xlarge">
            <Logo height="24px" width="auto" />
          </Box>
          <Box padding="xlarge">{options(closeDrawer, openDrawer)}</Box>
        </>
      )}
    />
  );
}

// @ts-ignore
export default withRouter(NavbarSideDrawer);
